<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>استلام بضاعة محولة من فرع آخر</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
        هنا يتم عرض جميع البضاعة المحولة من فروع آخرى لاستلامها
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' v-if='mainValidationErrors'>
                <ul v-if='mainValidationErrors'>
                    <li v-for='err in mainValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='col-lg-12' style="margin:0px;padding:0px">
                <div class='col-lg-3 col-md-3 col-sm-3' style="padding: 5px 5px">
                      <label>من فرع</label>
                      <select class="form-control"  v-model="from_branch_id">
                        <option v-for="item in allBranches" v-bind:key="item.id" v-bind:value="item.id">
                          {{ item.name }}
                        </option>
                      </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-3' style="padding: 5px 5px">
                      <label>الى فرع</label>
                      <select class="form-control"  v-model="to_branch_id">
                        <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                          {{ item.name }}
                        </option>
                      </select>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-3' style="padding: 5px 5px">
                  <tbDate  :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-3' style="padding: 5px 5px">
                  <tbDate  :mytitle='toTitle' v-model= 'date_to' ></tbDate>
                </div>
                <div class='form-group col-lg-2 col-sm-2' style="padding: 5px 5px">
                  <label>النوع:</label>
                  <select class="form-control" style="padding: 0px" v-model="status">
                    <option v-for="type in types" v-bind:key="type.id" v-bind:value="type.id">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-12 col-md-12 col-sm-12' style="padding: 0px 0px 15px 0px; text-align: center;">
                  <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md'>
                    <b> عرض حسب الفلترة </b>
                  </button>
                  <button @click='GetNotPostedData()' type='button' class='btn btn-outline btn-primary btn-md'>
                    <b> عرض جميع الغير مستلم </b>
                  </button>
                </div>
              </div>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>

                        <th style='text-align: center'>من فرع</th>
                        <th style='text-align: center'>أمين المخزن</th>
                        <th style='text-align: center'>التاريخ</th>
                        <th style='text-align: center'>ملاحظات</th>
                        <th style='text-align: center'>الاجراء</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                        <td align='center'>{{record.branch_from_name}}</td>
                        <td align='center' v-show="record.storekeeper_to_name">{{record.storekeeper_to_name}}</td>
                        <td align='center' v-show="!record.storekeeper_to_name">غير مستلم</td>
                        <td align='center'>{{record.date}}</td>
                        <td align='center'>{{record.notes_to}}</td>
                        <td align='center'>
                            <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                            <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>عرض</button>
                          </td>
                      </tr>
                  </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>ترحيل إذن </h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class='form-group col-lg-2 col-md-2 col-sm-6'>
                  <label>الكود:</label> {{record.id}}
                </div>
                <div class='form-group col-lg-4 col-md-4 col-sm-6'>
                  <label>من فرع:</label> {{record.branch_from_name}}
                </div>
                <div class='form-group col-lg-6 col-md-6 col-sm-6'>
                  <label>التاريخ:</label> {{record.date}}
                </div>
                <div class='form-group col-lg-12 col-md-12 col-sm-12'>
                  <label>ملاحظات:</label> {{record.notes_to}}
                </div>
                  <div v-show="parseInt(record.status) === 0" class='form-group col-lg-3 col-md-3  col-sm-12'   style="padding: 0px 5px 0px 5px">
                    <label>الصنف:</label>
                    <input @keypress="isLocked($event)" :value='alteredRec.item' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div v-show="parseInt(record.status) === 0" class='form-group col-lg-2 col-md-2  col-sm-4'   style="padding: 0px 5px 0px 5px">
                    <label>الكمية المرسلة:</label>
                    <input @keypress="isLocked($event)" :value='alteredRec.amount' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div v-show="parseInt(record.status) === 0" class='form-group col-lg-2 col-md-2  col-sm-4'   style="padding: 0px 5px 0px 5px">
                    <label>الكمية المستلمة:</label>
                    <input @keypress="isNumber($event)"  v-model='alteredRec.receipt_amount' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div class='form-group col-lg-2 col-md-2 col-sm-4' style="padding: 0px 5px 0px 5px">
                    <label>المخزن:</label>
                    <select class="form-control" style="padding: 0px" v-model="alteredRec.store_to_id">
                      <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">
                        {{ store.name }}
                      </option>
                    </select>
                  </div>
                  <div v-show="parseInt(record.status) === 0" class='form-group col-lg-3 col-md-3  col-sm-4'   style="padding: 25px 5px 0px 5px">
                    <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                    <button @click='saveItemData' type='button' class='btn btn-outline btn-primary btn-md btn-block'>حفظ الكمية المستلمة</button>
                  </div>

                  <table width='100%' class='table  table-bordered ' >
                    <thead>
                      <tr>
                        <th style='text-align: center'>م</th>
                        <th style='text-align: center'>الصنف</th>
                        <th style='text-align: center'>الكمية المرسلة</th>
                        <th style='text-align: center'>الكمية المستلمة</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr :class="{highlight :alteredRec.id == record.id}" v-for='(record, index) in invoiceItems' :key='record.id' v-on:click="showRec(record)">
                        <td style="padding:2px" align='center'>{{index +1}}</td>
                        <td style="padding:2px" align='right'>{{record.item}}</td>
                        <td style="padding:2px;text-align: center" align='right'>{{record.amount}}</td>
                        <td style="padding:2px;text-align: center" align='center'>{{record.receipt_amount}}</td>
                      </tr>
                    </tbody>
                  </table>
                <div v-show="parseInt(record.status) === 0" class='col-lg-12 col-sm-12' style='padding: 0px;margin:0px'>
                  <div class='form-group col-lg-8 col-md-8  col-sm-4'   style="padding: 0px 5px 0px 5px">
                    <label>ملاحظات:</label>
                    <input v-model='record.notes_to' class='form-control' name='invoic_id' type='text'>
                  </div>
                  <div class='form-group col-lg-4 col-md-4  col-sm-4'   style="padding: 25px 5px 0px 5px">
                    <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                    <button @click='saveTransferBranchReceipt' type='button' class='btn btn-outline btn-primary btn-md btn-block'>حفظ وترحيل الاذن</button>
                  </div>
                </div>

              </fieldset>
            </div>
            <div class='modal-footer'>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'return_purchase_masters',
  data () {
    return {
      fromTitle: 'من',
      toTitle: 'إلى',
      date_from: '',
      date_to: '',
      dateTitle: 'تاريخ الفاتورة',
      branches: {},
      allBranches: {},
      types: [{id: 1, name: 'مستلم'}, {id: 0, name: 'غير مستلم'}],
      from_branch_id: '',
      to_branch_id: '',
      validationErrors: '',
      status: 1,
      stores: {},
      branch_id: '',
      records: {},
      record: {},
      alteredRec: {},
      invoiceItems: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      isLoadingDeleteItem: false
    }
  },
  created () {
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    today = dd + '-' + mm + '-' + yyyy
    this.date_from = today
    this.date_to = today
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch_id = localStorage.getItem('BrancheID')
    this.to_branch_id = localStorage.getItem('BrancheID')
    this.GetAllBranches()
  },
  methods: {
    changeBranche () {
      let i = this.branches.findIndex(x => x.id === parseInt(this.to_branch_id))
      if (i > -1) {
        this.stores = this.branches[i].stores
      }
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isLocked: function (evt) {
      evt.preventDefault()
    },
    GetAllBranches () {
      this.isLoadingData = true
      this.mainValidationErrors = ''
      axios.post(this.$apiURL + 'getBranches', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.allBranches = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    GetData () {
      this.isLoadingData = true
      this.mainValidationErrors = ''
      axios.post(this.$apiURL + 'getTransferBranchReceiptMasters', {
        token: localStorage.getItem('token'),
        branch_id: this.from_branch_id,
        to_branch_id: this.to_branch_id,
        date_from: this.date_from,
        date_to: this.date_to,
        status: this.status
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    GetNotPostedData () {
      this.isLoadingData = true
      this.mainValidationErrors = ''
      axios.post(this.$apiURL + 'getAllTransferBranchReceipt', {
        token: localStorage.getItem('token'),
        branch_id: this.to_branch_id
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      this.alteredRec = ''
      this.record = recID
      this.getInvoiceItems()
      this.changeBranche()
    },
    getInvoiceItems () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getTransferBranchReceiptItems', {
        token: localStorage.getItem('token'),
        transfer_branch_master_id: this.record.id
      })
        .then(({ data }) => {
          this.invoiceItems = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showRec (recID) {
      this.alteredRec = recID
    },
    saveItemData () {
      this.validationErrors = ''
      this.successShow = false
      this.errorShow = false
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveTransferBranchItemReceipt', {
        token: localStorage.getItem('token'),
        id: this.alteredRec.id,
        receipt_amount: this.alteredRec.receipt_amount,
        store_to_id: this.alteredRec.store_to_id
      })
        .then(res => {
          this.isLoadingSave = false
          this.invoiceItems = res.data
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    saveTransferBranchReceipt () {
      this.validationErrors = ''
      this.successShow = false
      this.errorShow = false
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveTransferBranchReceipt', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        notes_to: this.record.notes_to
      })
        .then(res => {
          this.isLoadingSave = false
          this.invoiceItems = res.data
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/purchases/ReceiptBranchTransfer.vue